import { ToggleGroup, ToggleGroupItem, ToggleGroupProps } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ProductType } from '../../enums/productType'

interface ProductTypeToggleGroupProps extends Omit<ToggleGroupProps, 'items'> {
  withLabels?: boolean
}

export const ProductTypeToggleGroup = ({
  withLabels = false,
  ...toggleGroupProps
}: ProductTypeToggleGroupProps): ReactElement => {
  const { t } = useTranslation()

  const productTypeItems: ToggleGroupItem[] = useMemo(
    () => [
      {
        icon: 'box',
        value: ProductType.Goods,
        ...(withLabels
          ? { label: t('external_invoices.product_type_toggle_group.label.goods') }
          : { tooltipLabel: t('external_invoices.product_type_toggle_group.tooltip_label.goods') }),
      },
      {
        icon: 'wrench',
        value: ProductType.Services,
        ...(withLabels
          ? { label: t('external_invoices.product_type_toggle_group.label.services') }
          : { tooltipLabel: t('external_invoices.product_type_toggle_group.tooltip_label.services') }),
      },
    ],
    [t, withLabels],
  )

  return <ToggleGroup {...toggleGroupProps} items={productTypeItems} />
}
